<template>
  <section id="about" class="about">
    <div>
      <div class="section-title">
        <h2>計畫、產學(Project)</h2>
      </div>
      <hr />
      <h2 class="project-title">A. 專題研究計畫:</h2>
      <hr />
      <p class="project-content" v-for="item1 in project" :key="item1.num">
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
      </p>
      <hr />
      <h2 class="project-title">B. 業界產學合作(計畫主持人)(共同主持人)</h2>
      <hr />
      <p
        class="project-content"
        v-for="item1 in cooperation_project"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
      </p>
      <hr />
      <h2 class="project-title">C. 校內專題研究(計畫主持人)</h2>
      <hr />
      <p
        class="project-content"
        v-for="item1 in school_research_projects"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
      </p>
    </div>
  </section>
</template>

<script>
import { projectPath } from "../assets/projectRouter/project.js";
export default {
  name: "project",
  data() {
    return {
      project: [
                {
          num: "[24].",
          name: "116學年度【應用人工智慧、物聯網與低成本感測器建立職業噪音與可呼吸性粉塵的個人暴露評估模式(3/3)】",
          ca: "(116/08/01~117/07/31)",
          num2: "【NSTC 114-2314-B-039 -028 -MY3】- 共同主持人",
          cal: "",
        },
        {
          num: "[23].",
          name: "115學年度【應用人工智慧、物聯網與低成本感測器建立職業噪音與可呼吸性粉塵的個人暴露評估模式(3/3)】",
          ca: "(115/08/01~117/07/31)",
          num2: "【NSTC 114-2314-B-039 -028 -MY3】- 共同主持人",
          cal: "",
        },
        {
          num: "[22].",
          name: "114學年度【應用人工智慧、物聯網與低成本感測器建立職業噪音與可呼吸性粉塵的個人暴露評估模式(1/3)】",
          ca: "(114/08/01~117/07/31)",
          num2: "【NSTC 114-2314-B-039 -028 -MY3】- 共同主持人",
          cal: "",
        },
        {
          num: "[21].",
          name: "符合SDG以智慧農業協助偏鄉的人才培育服務與學習",
          ca: "(2023-08-01~2025-07-31)",
          num2: "【112年大專校院教學實踐研究計畫-教育部-計畫主持人】【PSR1121499】 ",
          cal: "",
        },
        {
          num: "[20].",
          name: "112年度 【具安全性異質工業物聯網之智慧製造系統場域建置與認證(3/3)】",
          ca: "(112/06/01~113/05/31)",
          num2: "【科技部 NSTC 112-2218-E-194-006】-共同主持人 ",
          cal: "5,000,000",
          path: projectPath[1],
        },
        {
          num: "[19].",
          name: "111年度 【具安全性異質工業物聯網之智慧製造系統場域建置與認證(2/3)】",
          ca: "(111/06/01~112/05/31)",
          num2: "【科技部 MOST 111-2218-E-194-007】-共同主持人 ",
          cal: "(4,800,000)",
          path: projectPath[0],
        },
        {
          num: "[18].",
          name: "110年度 【具安全性異質工業物聯網之智慧製造系統場域建置與認證(1/3)】",
          ca: "(110/11/01~111/05/31)",
          num2: "【科技部 MOST 110-2218-E-194-010】-共同主持人 ",
          cal: "(4,800,000)",
        },
        {
          num: "[17].",
          name: "具安全性異質工業物聯網之智慧製造系統場域建置與認證",
          ca: "(2020/12/01~2021/05/31)",
          num2: "【109科技部-國家實驗研究院-發展智慧製造及半導體先進程資安實測場域專案計畫-共同主持人】",
          cal: "(4,800,000)",
        },
        {
          num: "[16].",
          name: "引入多媒體工具培訓個人化專業MVC架構專案程式開發學習環境",
          ca: "(2018/08/01~2019/07/31)",
          num2: "【107年大專校院教學實踐研究計畫-教育部-計畫主持人】【NCUT-18-E-CC-034 】",
          cal: "(157,500)",
        },
        {
          num: "[15].",
          name: "去密碼化近場通訊技術應用於遠端多伺服器認證之研究",
          ca: "(2015/08~2016/07)",
          num2: "【科技部MOST 104-2221-E-167-007 計畫主持人】",
          cal: "(540,000)",
        },
        {
          num: "[14].",
          name: "利用異質通道進行文件重要資訊隨身保護研究",
          ca: "(2014/08~2015/07)",
          num2: "【科技部MOST 103-2221-E-167-028 計畫主持人】",
          cal: "(490,000)",
        },
        {
          num: "[13].",
          name: "建構癌病診治資訊標準化互通機制及其量化分析應用探討子計畫五:癌病診治資訊互通之安全管控與隱私保護",
          ca: "(2013/08~2014/07)",
          num2: "【國科會NSC-102-2221-E-320-003 計畫共同主持人】",
          cal: "(413,000)",
        },
        {
          num: "[12].",
          name: "【大專生國科會計畫】(林琮皓)APP智慧財產嵌入研究-以Shiv3D遊戲開發為例",
          ca: "(2013/ 07~2014/02)",
          num2: "【國科會NSC-102-2815-C-167-009-E計畫主持人】",
          cal: "(47,000)",
        },
        {
          num: "[11].",
          name: "【大專生國科會計畫】(莊侑錡) Shiva3D與手機遊戲安全 ",
          ca: "(2012/07 ~ 2013/02)",
          num2: "【國科會NSC-101-2815-C-167-014-E計畫主持人】",
          cal: "(47,000)",
        },
        {
          num: "[10].",
          name: "應用資訊隱藏技術進行數位多媒體版權資料庫可逆保護偵測研究",
          ca: "(2011/08~2012/07)",
          num2: "【國科會NSC-100-2221-E-167-017計畫主持人】",
          cal: "(490,000)",
        },
        {
          num: "[09].",
          name: "以RFID階層式機密共享分層合作實現智慧生活安全防護開發研究",
          ca: "(2010/08~2011/07)",
          num2: "【國科會NSC-99-2221-E-167-014計畫主持人】",
          cal: "(496,000)",
        },
        {
          num: "[08].",
          name: "利用數位機械紋痕附加數位簽章進行數位鑑識之研究",
          ca: "(2009/08 ~ 2010/07)",
          num2: "【國科會NSC-98-2221-E-167-013計畫主持人】",
          cal: "(365,000)",
        },
        {
          num: "[07].",
          name: "98, 99, 100年教育部補助發展學校典範特色計畫",
          ca: "(2009/05 ~ 2011/12) ",
          num2: "【智慧家庭休閒娛樂與健康照顧整合系統開發及創新教學環境建構總計畫共同主持人】",
          cal: "(2,000,000)",
        },
        {
          num: "[06].",
          name: "98, 99, 100, 101, 102, 103, 104, 105, 106, 107年度教育部資訊志工團隊計畫 ",
          ca: "(2009/05 ~ 2019/07) ",
          num2: "__(9893106)(99M93103A)(00M93102A)(M01931504)(M02931501)(M03931502)(M04931502)(M05931502)(M06931501)(M07931501)【計畫主持人+勤益NEMU團隊 (980096, 990058, 100018, 101089, 102063, 103012, 104002, 105004, 106002, 107001) 領隊】",
          cal: "(1,495,000)",
        },
        {
          num: "[05].",
          name: "98, 99, 100, 101, 102, 103, 104, 105 學年度「國立勤益科技大學縮短中小學城鄉數位落差資訊教育計劃」",
          ca: "(2009/01 ~ 2017/06)",
          num2: "【勤益科大(副)領隊+勤益NEMU團隊領隊】",
          cal: "(2,611,000)",
        },
        {
          num: "[04].",
          name: "98,99教育部正規教育軟體人才培育推動計劃 ",
          ca: "(2009/06~ 2011/01))",
          num2: "(CY09ACC002)(CY10ACC001【示範學校計畫共同主持人】",
          cal: "(420,000)",
        },
        {
          num: "[03].",
          name: "98年度教育部「資通訊重點領域課程推廣計畫」 ",
          ca: "(2009/05 ~ 2010/04)",
          num2: "(CY09ACC001)【數位家庭子計畫共同主持人】",
          cal: "(1,030,000)",
        },
        {
          num: "[02].",
          name: "資訊專業與國際證照輔導暨師資培訓",
          ca: "(2008/08 ~ 2009/07) ",
          num2: "【國立勤益科技大學97年度教學卓越計畫F-1-1子計畫主持人】(CY08AEM-卓越01)",
          cal: "(630,000)",
        },
        {
          num: "[01].",
          name: "無線射頻辨識系統應用於校園身分識別、差勤管理及防弊之研究",
          ca: "(2006/05 ~ 2007/04)",
          num2: "【國科會NSC-95-2622-E-266-002-CC3計畫主持人】",
          cal: "(597,000)",
        },
      ],
      cooperation_project: [
        {
          num: "[30].",
          name: "資安管理與技術人才精進計畫(NCUT25TCC003/AA14931003N)",
          ca: "(2025.02.01~2026.02.01)",
          num2: "(德欣寰宇科技股份有限公司) ",
          cal: "(00,000)",
        },
        {
          num: "[29].",
          name: "開發管理暨智能數位製造系統研發計畫(NCUT21TCC002/AA10931003N-共同主持人)",
          ca: "(2021/05~2022/02)",
          num2: "(東治實業股份有限公司) ",
          cal: "(–00,000)",
        },
        {
          num: "[28].",
          name: "具安全性異質工業物聯網之智慧製造系統場域建置與認證(NCUT20TCC011)",
          ca: "(2020/12~2021/05)",
          num2: "(國立中正大學) ",
          cal: "(300,000)",
        },
        {
          num: "[27]. ",
          name: "智慧機器人創意應用專案訓練案(A07904006N-共同主持人)",
          ca: "(2018/10~2019/03)",
          num2: "(紐芬蘭事業有限公司) ",
          cal: "(180,000)",
        },
        {
          num: "[26].",
          name: "106學年度資訊志工暨產學合作案(A06931006)",
          ca: "(2017/06~2018/05)",
          num2: "(教育部/歐萬整合技術服務有限公司)",
          cal: "(255,000/45,000)(300,000)",
        },
        {
          num: "[25]. ",
          name: "工業數據匯流平台研究(NCUT17TCC008-共同主持人) ",
          ca: "(2017/07/13~2017/11/30) ",
          num2: "(財團法人資訊工業策進會) ",
          cal: "(310,000)",
        },
        {
          num: "[24].",
          name: "互動式最適消費需求配對研究(NCUT17TCC0..-共同主持人)",
          ca: "(2017/01~2017/06)",
          num2: "(兆盛單車企業社)",
          cal: "(310,000)",
        },
        {
          num: "[23]. ",
          name: "大數據之機器學習互動應用研究(NCUT16TCC011)",
          ca: "(2016/06~2017/03) ",
          num2: "(永億資訊有限公司) ",
          cal: "(315,000)",
        },
        {
          num: "[22].",
          name: "無人旅館雲端服務設計與設備整合規劃(NCUT16TCC009-協同主持人) ",
          ca: "(2016/09/27~2016/12/15)",
          num2: "(資訊工業策進會)",
          cal: "(300,000)",
        },
        {
          num: "[21].",
          name: "多媒體國際證照教學改善研究案(NCUT15TCC001)",
          ca: "(2015/01~2015/10)",
          num2: "(永億資訊有限公司)",
          cal: "(69,000)",
        },
        {
          num: "[20].",
          name: "103聽障溝通學習服務資源平台研究開發案(NCUT14TCC003)",
          ca: "(2014/03~2014/12)",
          num2: "(中華民國聲暉聯合會)",
          cal: "(112,000)",
        },
        {
          num: "[19].",
          name: "紮根 MVC 架構遊戲設計研究案(NCUT13TCC005)",
          ca: "(2013/08~2014/05)",
          num2: "(向上遊戲科技股份有限公司)",
          cal: "(67,200)",
        },
        {
          num: "[18]. ",
          name: "聽障溝通學習服務資源平台研究開發案(NCUT13TCC001-共同主持人)",
          ca: "(2013/03~2013/12)",
          num2: "(中華民國聲暉聯合會)",
          cal: "(224,000)",
        },
        {
          num: "[17].",
          name: "2012醫療器材資料庫系統開發與維護案(NCUT12TCC003-共同主持人)",
          ca: "(2012/08~2013/04)",
          num2: "(工業技術研究院)",
          cal: "(100,800)",
        },
        {
          num: "[16].",
          name: "虛擬實境數位教學系統整合研究開發案(CY11TCC005)",
          ca: "(2011/05~2012/02)",
          num2: "(帝旺數位科技有限公司)",
          cal: "(400,000)",
        },
        {
          num: "[15].",
          name: "綠色網路個人環境串接研究計劃(CY09TCC007)",
          ca: "(2009/03~2009/12) ",
          num2: "(強迅科技有限公司)",
          cal: "(110,000)",
        },
        {
          num: "[14]. ",
          name: "智慧型衛星定位暨行動地理座標即時監控系統開發研究案(CY08TCC007)",
          ca: "(2008/03~2008/12) ",
          num2: "(開得數位科技顧問有限公司)",
          cal: "(480,000)",
        },
        {
          num: "[13]. ",
          name: "人力資料庫系統建置規劃案 (CY08TCC006)",
          ca: "(2008/02~2008/04)",
          num2: "(行政院原住民族委員會)",
          cal: "(106.800)",
        },
        {
          num: "[12]. ",
          name: "綠色能源空間溫度檢測系統開發研究案 (CY08TCC008)",
          ca: "(2008/03~2008/12)",
          num2: "(開得數位科技顧問有限公司) ",
          cal: " (192,000)",
        },
        {
          num: "[11]. ",
          name: "FLASH 動態影片加值嵌入動態連結系統研究(CY08TCC002)",
          ca: "(2008/01~2008/12)",
          num2: "(開得數位科技顧問有限公司) ",
          cal: "(115,000)",
        },
        {
          num: "[10].",
          name: "財團法人張明王國秀文教基金會線上申請系統(CY08TCC005-共同主持人)",
          ca: "(2008/01~2008/10)",
          num2: "(張明王國秀文教基金會)",
          cal: "(———)",
        },
        {
          num: "[09]. ",
          name: "ZigBee區域網路實驗室建置、應用推廣暨教學研究",
          ca: "(2006/10~2007/04)",
          num2: "(台達電MMBU磁性微波事業單位)",
          cal: "(200,000)",
        },
        {
          num: "[08].",
          name: "無線射頻辨識系統應用於校園身分識別、差勤管理及防弊",
          ca: "(2006/05 ~ 2007/04)",
          num2: "(艾發數位股份有限公司)",
          cal: "(250,000)",
        },
        {
          num: "[07].",
          name: "無線電水文氣象測報系統軟體更新開發案",
          ca: "(2006/01 ~ 2006/05) ",
          num2: "(翰昇環境科技股份有限公司) ",
          cal: "(1,100,000)",
        },
        {
          num: "[06]. ",
          name: "「地方中小企業e化輔導工作」計畫",
          ca: "(2006/03 ~ 2006/11)",
          num2: "(伺服網路科技股份有限公司)",
          cal: "(150,000)",
        },
        {
          num: "[05].",
          name: "台北市政府衛生局志願工作網系統建置案",
          ca: "(2005/09 ~ 2005/12)",
          num2: "(國際脈絡股份有限公司)",
          cal: "(120,000)",
        },
        {
          num: "[04].",
          name: "GPRS n維條碼於行動商務之影響研究",
          ca: "(2005/07 ~ 2006/04)",
          num2: "(旭德數位股份有限公司)",
          cal: "(120,000)",
        },
        {
          num: "[03].",
          name: "資訊科技應用於節省慢性病行動醫療成本之研究",
          ca: "(2005/07 ~ 2006/03)",
          num2: "(國際脈絡股份有限公司)",
          cal: "(180,000)",
        },
        {
          num: "[02].",
          name: " RFID無線射頻辨識技術於資訊教學應用之研究",
          ca: "(2005/07 ~ 2006/05)",
          num2: "(艾發數位股份有限公司)",
          cal: "(120,000)",
        },
        {
          num: "[01].",
          name: "VOD隨選視訊技術於資訊補救教學應用之研究",
          ca: "(2005/07 ~ 2006/05)",
          num2: "(華人數位股份有限公司)",
          cal: "(120,000)",
        },
      ],
      school_research_projects: [
        {
          num: "[21].",
          name: "工控資安驗證場域次世代安全資訊與事件管理實務研究與實現",
          ca: "國立勤益科技大學",
          num2: "(2025/01/01-2025/10/31)",
          cal: "",
        },
        {
          num: "[20].",
          name: "實現一個安全、永續、培力的去中心化區塊鏈星際文件系統數位資產認證系統",
          ca: "國立勤益科技大學",
          num2: "(2023/01/01-2023/10/31)",
          cal: "",
        },
        {
          num: "[19].",
          name: "一種應用NFC技術實現OT場域IoT設備資安防水牆",
          ca: "國立勤益科技大學",
          num2: "(2022/01/01-2022/10/31)",
          cal: "",
        },
        {
          num: "[18].",
          name: "適合穿戴裝置大數據之邊際霧運算資訊安全",
          ca: "國立勤益科技大學",
          num2: "(2021/01/01-2021/10/31)",
          cal: "",
        },
        {
          num: "[17].",
          name: "USR Hub種子計畫-原鄉永續智慧溫室番茄彩椒產銷提升計畫-111(NCUT GG11840501G2)",
          ca: "國立勤益科技大學",
          num2: "(2021/01/01-2022/12/31)",
          cal: "(1,250,000)",
        },
        {
          num: "[16].",
          name: "一種應用NFC技術實現OT場域IoT設備資安防水牆",
          ca: "國立勤益科技大學",
          num2: "(2021/10/31~2022/01/01)",
          cal: "(50,000)",
        },
        {
          num: "[15].",
          name: "適合穿戴裝置大數據之邊際霧運算資訊安全(NCUT 21-R-CC-)",
          ca: "國立勤益科技大學",
          num2: "(2021/01/01~2021/10/31)",
          cal: "(50,000)",
        },
        {
          num: "[14].",
          name: "USR Hub種子計畫-原鄉永續智慧溫室番茄彩椒產銷提升計畫(NCUT G10840501D0)",
          ca: "國立勤益科技大學",
          num2: "(2021/01/01~2021/12/31)",
          cal: "(1,250,000)",
        },
        {
          num: "[13].",
          name: "USR Hub種子計畫-原鄉永續智慧溫室番茄彩椒產銷提升計畫(NCUT G09840501G2/G09840501D0)",
          ca: "國立勤益科技大學",
          num2: "(2020/01/01~2020/12/31)",
          cal: "(1,250,000)",
        },
        {
          num: "[12].",
          name: "USR Hub種子計畫-原鄉永續智慧溫室番茄彩椒產銷提升計畫(NCUT G08840501D0)",
          ca: "國立勤益科技大學",
          num2: "(2019/07/01~2019/12/31)",
          cal: "(880,000)",
        },
        {
          num: "[11].",
          name: "一種整合型物聯網無線感測網路電子支付通訊認證與資料存取安全性研究(NCUT 19-R-CC-009)",
          ca: "國立勤益科技大學",
          num2: "(2019/01/01~2019/10/31)",
          cal: "(50,000)",
        },
        {
          num: "[10].",
          name: "安全穩定的物聯網無線感測網路通訊認證系統(NCUT 18-R-CC-011)",
          ca: "國立勤益科技大學",
          num2: "(2018/01/01~2018/10/31)",
          cal: "(50,000)",
        },
        {
          num: "[09].",
          name: "一種新穎的整合物聯網網路之多使用者通訊認證與金鑰授權機制研究(NCUT 17-R-CC-016)",
          ca: "國立勤益科技大學",
          num2: "(2017/01/01~2017/10/31)",
          cal: "(50,000)",
        },
        {
          num: "[08].",
          name: "雲端智能導覽機-資工人的一天(105-NCUT-O-CC002)",
          ca: "國立勤益科技大學",
          num2: "(2015/12/31~2016/05/01)",
          cal: "(470,000)",
        },
        {
          num: "[07].",
          name: "利用透明度視覺密碼輔助進行智慧財產文件竄改偵測與回復研究(NCUT-14-R-CC-015)",
          ca: "國立勤益科技大學",
          num2: "(2014/01/01~2014/12/31)",
          cal: "(50,000)",
        },
        {
          num: "[06].",
          name: "利用疊代式快速反應碼進行行動雲端視覺解密研究(NCUT-13-R-CC-001)",
          ca: "國立勤益科技大學",
          num2: "(2013/01/01~2013/12/31)",
          cal: "(50,000)",
        },
        {
          num: "[05].",
          name: "應用ZigBee無線個人區域網路與GPS定位之科技監控研究 (CY98ACC001)",
          ca: "國立勤益科技大學",
          num2: "(2009/01/01 ~ 2009/10/31)",
          cal: "(90,000)",
        },
        {
          num: "[04].",
          name: "互動式3D立體投影虛擬實境專題建置研究",
          ca: "國立勤益科技大學",
          num2: "(2008/02~2008/07)",
          cal: "(1,600,000)",
        },
        {
          num: "[03].",
          name: "新世代無線感測網路IEEE 802.15.4/ZigBee快速傳輸網路",
          ca: "醒吾技術學院",
          num2: "(2006/06~2007/05)",
          cal: "",
        },
        {
          num: "[02].",
          name: "無線射頻辨識系統應用於校園身分識別、差勤管理及防弊",
          ca: "醒吾技術學院",
          num2: "(2006/03~2006/12)",
          cal: "",
        },
        {
          num: "[01].",
          name: "無線藍芽個人區域網路之有效服務品質保證繞徑協定研究",
          ca: "醒吾技術學院",
          num2: "(2005/10~2006/09)",
          cal: "",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}
@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC_Regular", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
  cursor: pointer;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

.ct1 {
  color: rgb(103, 38, 146);
}
.ct2 {
  color: blue;
}
.ct3 {
  color: coral;
}
.ct4 {
  color: red;
}
.ct5 {
  color: rgb(4, 174, 173);
}
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}

.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  font-family: "NotoSansTC_Bold";
  text-align: center;
  padding-bottom: 30px;
}
.section-title h2 {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #555;
}
.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# publicaiton
--------------------------------------------------------------*/
.project-title {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 3vh;
  text-align: center;
}
.project-content {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #389402f1;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}
.about ul {
  list-style: none;
  padding: 0;
}
.about ul li {
  padding-bottom: 10px;
}
.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}
.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
